import type { NodeAnimationAsset } from '../content/types'

interface TransparentAnimationProps {
  asset: NodeAnimationAsset
  animate: boolean
  onError: () => void
}

export function TransparentAnimation({ asset, animate, onError }: TransparentAnimationProps) {
  return (
    <img
      key={animate ? `animation-${asset.src}` : `poster-${asset.poster}`}
      className="animation-preview"
      src={animate ? asset.src : asset.poster}
      alt=""
      aria-hidden="true"
      draggable={false}
      decoding="async"
      data-animation-src={asset.src}
      data-animate={String(animate)}
      onError={onError}
    />
  )
}
